import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.map.js";
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, createCommentVNode as _createCommentVNode, withCtx as _withCtx, Transition as _Transition, Teleport as _Teleport, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "shrink-0 border-b border-slate-200 bg-gradient-to-r from-blue-50/50 via-white to-orange-50/30 px-6 py-5"
};
const _hoisted_2 = {
  class: "flex items-start justify-between gap-4"
};
const _hoisted_3 = {
  class: "mt-2 text-2xl font-semibold text-slate-900"
};
const _hoisted_4 = {
  class: "flex-1 overflow-y-auto px-6 py-6"
};
const _hoisted_5 = {
  class: "max-w-3xl space-y-6"
};
const _hoisted_6 = {
  class: "rounded-xl border border-slate-200 bg-white p-5"
};
const _hoisted_7 = {
  class: "grid gap-5"
};
const _hoisted_8 = {
  key: 0,
  class: "mt-1.5 text-xs text-red-500"
};
const _hoisted_9 = {
  class: "rounded-xl border border-slate-200 bg-slate-50 p-4"
};
const _hoisted_10 = {
  class: "flex flex-wrap items-center justify-between gap-3"
};
const _hoisted_11 = {
  class: "mt-4"
};
const _hoisted_12 = {
  class: "rounded-xl border border-slate-200 bg-white p-5"
};
const _hoisted_13 = {
  class: "grid gap-5 md:grid-cols-2"
};
const _hoisted_14 = {
  key: 0,
  class: "mt-1.5 text-xs text-red-500"
};
const _hoisted_15 = {
  key: 0,
  class: "mt-1.5 text-xs text-red-500"
};
const _hoisted_16 = {
  class: "mt-5 rounded-xl border border-slate-200 bg-slate-50 p-4"
};
const _hoisted_17 = {
  class: "flex flex-wrap items-center justify-between gap-3"
};
const _hoisted_18 = {
  key: 0,
  class: "mt-4 grid gap-4 md:grid-cols-[180px_160px_1fr]"
};
const _hoisted_19 = {
  class: "mt-5 flex items-center justify-between rounded-2xl border border-slate-200 p-4"
};
const _hoisted_20 = {
  class: "shrink-0 flex items-center justify-between gap-4 border-t border-slate-200 bg-white px-6 py-4"
};
const _hoisted_21 = {
  class: "text-sm text-slate-500"
};
const _hoisted_22 = {
  class: "flex items-center gap-3"
};
const _hoisted_23 = ["disabled"];
const _hoisted_24 = {
  key: 0,
  class: "h-4 w-4 animate-spin",
  fill: "none",
  viewBox: "0 0 24 24"
};
import { computed, reactive, watch } from 'vue';
import { ElMessage } from 'element-plus';
import { useUserStore } from '@/stores/user';
import UserSelector from '@/components/UserSelector/index.vue';
import AppModal from '@/components/AppModal.vue';
export default {
  __name: 'ReminderDefinitionFormModal',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    detail: {
      type: Object,
      default: null
    },
    mode: {
      type: String,
      default: 'create'
    },
    saving: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:visible', 'submit'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emit = __emit;
    const userStore = useUserStore();
    const form = reactive(createEmptyForm());
    const fieldErrors = reactive({
      title: '',
      firstSendTime: '',
      deadlineTime: ''
    });
    const titleText = computed(() => props.mode === 'edit' ? '编辑提醒' : '新建提醒');
    const submitText = computed(() => props.mode === 'edit' ? '保存修改' : '创建提醒');
    const footerHint = computed(() => props.mode === 'edit' ? '保存后会同步更新现有提醒任务。' : '创建后立即按定义生成对应接收人的提醒任务。');
    watch(() => props.visible, async visible => {
      if (!visible) return;
      resetForm();
      if (props.detail) {
        Object.assign(form, buildFormModel(props.detail));
      }
    }, {
      immediate: true
    });
    function createEmptyForm() {
      return {
        title: '',
        content: '',
        remindSelf: false,
        receiverUserIds: [],
        firstSendTime: '',
        deadlineTime: '',
        autoCloseAtDeadline: false,
        repeatEnabled: false,
        repeatIntervalValue: 1,
        repeatIntervalUnit: 'DAY',
        maxReminderCount: 5
      };
    }
    function resetForm() {
      Object.assign(form, createEmptyForm());
      resetFieldErrors();
    }
    function buildFormModel(detail) {
      const repeat = normalizeRepeatInterval(detail.repeatIntervalMinutes);
      const currentUserId = userStore.userInfo?.userId;
      const receiverIds = (detail.receivers || []).map(item => item.userId);
      return {
        title: detail.title || '',
        content: detail.content || '',
        remindSelf: currentUserId ? receiverIds.includes(currentUserId) : false,
        receiverUserIds: receiverIds.filter(id => id !== currentUserId),
        firstSendTime: normalizeDateTime(detail.firstSendTime),
        deadlineTime: normalizeDateTime(detail.deadlineTime),
        autoCloseAtDeadline: Boolean(detail.autoCloseAtDeadline),
        repeatEnabled: Boolean(detail.repeatEnabled),
        repeatIntervalValue: repeat.repeatIntervalValue,
        repeatIntervalUnit: repeat.repeatIntervalUnit,
        maxReminderCount: detail.maxReminderCount || 5
      };
    }
    function buildSubmitPayload(includeId) {
      const repeatIntervalMinutes = form.repeatEnabled ? toRepeatIntervalMinutes(form.repeatIntervalValue, form.repeatIntervalUnit) : null;
      const currentUserId = userStore.userInfo?.userId;
      const allReceiverIds = [...form.receiverUserIds];
      if (form.remindSelf && currentUserId) {
        allReceiverIds.unshift(currentUserId);
      }
      const payload = {
        title: form.title.trim(),
        content: form.content?.trim() || null,
        receiverUserIds: allReceiverIds,
        firstSendTime: normalizeDateTime(form.firstSendTime),
        deadlineTime: normalizeDateTime(form.deadlineTime),
        autoCloseAtDeadline: Boolean(form.deadlineTime && form.autoCloseAtDeadline),
        repeatEnabled: form.repeatEnabled,
        repeatIntervalMinutes,
        maxReminderCount: form.repeatEnabled ? Number(form.maxReminderCount || 1) : null
      };
      if (includeId && props.detail?.id) {
        payload.id = props.detail.id;
      }
      return payload;
    }
    function normalizeRepeatInterval(minutes) {
      if (!minutes || minutes < 60) {
        return {
          repeatIntervalValue: minutes || 1,
          repeatIntervalUnit: 'MINUTE'
        };
      }
      if (minutes % 1440 === 0) {
        return {
          repeatIntervalValue: minutes / 1440,
          repeatIntervalUnit: 'DAY'
        };
      }
      if (minutes % 60 === 0) {
        return {
          repeatIntervalValue: minutes / 60,
          repeatIntervalUnit: 'HOUR'
        };
      }
      return {
        repeatIntervalValue: minutes,
        repeatIntervalUnit: 'MINUTE'
      };
    }
    function toRepeatIntervalMinutes(value, unit) {
      const numericValue = Number(value || 1);
      if (unit === 'DAY') return numericValue * 1440;
      if (unit === 'HOUR') return numericValue * 60;
      return numericValue;
    }
    function normalizeDateTime(value) {
      if (!value) return null;
      return String(value).replace(' ', 'T');
    }
    function validateTitle() {
      fieldErrors.title = form.title.trim() ? '' : '请输入提醒标题';
    }
    function validateFirstSendTime() {
      if (!form.firstSendTime) {
        fieldErrors.firstSendTime = '请选择首次提醒时间';
      } else {
        fieldErrors.firstSendTime = '';
        validateDeadlineTime();
      }
    }
    function validateDeadlineTime() {
      if (form.deadlineTime && form.firstSendTime) {
        const deadline = new Date(form.deadlineTime).getTime();
        const first = new Date(form.firstSendTime).getTime();
        fieldErrors.deadlineTime = deadline < first ? '截止时间不能早于首次提醒时间' : '';
      } else {
        fieldErrors.deadlineTime = '';
      }
    }
    function resetFieldErrors() {
      fieldErrors.title = '';
      fieldErrors.firstSendTime = '';
      fieldErrors.deadlineTime = '';
    }
    function validateForm() {
      if (!form.title.trim()) {
        ElMessage.warning('请输入提醒标题');
        return false;
      }
      if (!form.firstSendTime) {
        ElMessage.warning('请选择首次提醒时间');
        return false;
      }
      if (!form.remindSelf && !form.receiverUserIds.length) {
        ElMessage.warning('请至少选择一位提醒人员');
        return false;
      }
      if (form.deadlineTime && new Date(form.deadlineTime).getTime() < new Date(form.firstSendTime).getTime()) {
        ElMessage.warning('截止时间不能早于首次提醒时间');
        return false;
      }
      if (form.repeatEnabled) {
        if (!Number(form.repeatIntervalValue) || Number(form.repeatIntervalValue) < 1) {
          ElMessage.warning('请设置正确的重复间隔');
          return false;
        }
        if (!Number(form.maxReminderCount) || Number(form.maxReminderCount) < 1) {
          ElMessage.warning('请设置正确的最大提醒次数');
          return false;
        }
      }
      return true;
    }
    function handleClose() {
      emit('update:visible', false);
    }
    function handleSubmit() {
      if (!validateForm()) return;
      const includeId = props.mode === 'edit';
      emit('submit', buildSubmitPayload(includeId));
    }
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_switch = _resolveComponent("el-switch");
      const _component_el_date_picker = _resolveComponent("el-date-picker");
      const _component_el_input_number = _resolveComponent("el-input-number");
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      return _openBlock(), _createBlock(_Teleport, {
        to: "body"
      }, [_createVNode(_Transition, {
        name: "reminder-modal"
      }, {
        default: _withCtx(() => [_createVNode(AppModal, {
          visible: __props.visible,
          size: "3xl",
          "panel-class": "max-h-[92vh]",
          scrollable: false,
          onClose: handleClose
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", null, [_createElementVNode("h3", _hoisted_3, _toDisplayString(titleText.value), 1)]), _createElementVNode("button", {
            type: "button",
            class: "flex h-10 w-10 items-center justify-center rounded-full border border-slate-200 bg-white text-slate-400 transition-colors hover:border-slate-300 hover:text-slate-600",
            onClick: handleClose
          }, [...(_cache[11] || (_cache[11] = [_createElementVNode("svg", {
            class: "h-5 w-5",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M6 18L18 6M6 6l12 12"
          })], -1)]))])])]), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("section", _hoisted_6, [_cache[17] || (_cache[17] = _createElementVNode("div", {
            class: "mb-5 flex items-center justify-between"
          }, [_createElementVNode("div", null, [_createElementVNode("h4", {
            class: "text-base font-semibold text-slate-900"
          }, "提醒内容")]), _createElementVNode("span", {
            class: "rounded-full status-badge is-info px-3 py-1 text-xs font-medium"
          }, "核心配置")], -1)), _createElementVNode("div", _hoisted_7, [_createElementVNode("div", null, [_cache[12] || (_cache[12] = _createElementVNode("label", {
            class: "mb-2 block text-sm font-medium text-slate-700"
          }, [_createTextVNode("提醒标题 "), _createElementVNode("span", {
            class: "text-red-500"
          }, "*")], -1)), _createVNode(_component_el_input, {
            modelValue: form.title,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => form.title = $event),
            maxlength: "64",
            "show-word-limit": "",
            placeholder: "例如：跟进客户续签资料",
            class: _normalizeClass({
              'is-error': fieldErrors.title
            }),
            onBlur: validateTitle
          }, null, 8, ["modelValue", "class"]), fieldErrors.title ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(fieldErrors.title), 1)) : _createCommentVNode("", true)]), _createElementVNode("div", null, [_cache[13] || (_cache[13] = _createElementVNode("label", {
            class: "mb-2 block text-sm font-medium text-slate-700"
          }, "提醒内容", -1)), _createVNode(_component_el_input, {
            modelValue: form.content,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => form.content = $event),
            type: "textarea",
            rows: 4,
            maxlength: "300",
            "show-word-limit": "",
            resize: "none",
            placeholder: "补充提醒背景、执行要求或处理说明"
          }, null, 8, ["modelValue"])]), _createElementVNode("div", null, [_cache[16] || (_cache[16] = _createElementVNode("label", {
            class: "mb-2 block text-sm font-medium text-slate-700"
          }, [_createTextVNode("提醒人员 "), _createElementVNode("span", {
            class: "text-red-500"
          }, "*")], -1)), _createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [_cache[14] || (_cache[14] = _createElementVNode("div", null, [_createElementVNode("p", {
            class: "text-sm font-medium text-slate-800"
          }, "提醒自己"), _createElementVNode("p", {
            class: "mt-1 text-xs text-slate-500"
          }, "将提醒任务发送给自己的账号")], -1)), _createVNode(_component_el_switch, {
            modelValue: form.remindSelf,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => form.remindSelf = $event)
          }, null, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_11, [_cache[15] || (_cache[15] = _createElementVNode("p", {
            class: "mb-2 text-sm font-medium text-slate-800"
          }, "提醒他人", -1)), _createVNode(UserSelector, {
            modelValue: form.receiverUserIds,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => form.receiverUserIds = $event),
            multiple: "",
            placeholder: "点击选择提醒人员"
          }, null, 8, ["modelValue"])])])])])]), _createElementVNode("section", _hoisted_12, [_cache[25] || (_cache[25] = _createElementVNode("div", {
            class: "mb-5"
          }, [_createElementVNode("h4", {
            class: "text-base font-semibold text-slate-900"
          }, "时间与重复")], -1)), _createElementVNode("div", _hoisted_13, [_createElementVNode("div", null, [_cache[18] || (_cache[18] = _createElementVNode("label", {
            class: "mb-2 block text-sm font-medium text-slate-700"
          }, [_createTextVNode("首次提醒时间 "), _createElementVNode("span", {
            class: "text-red-500"
          }, "*")], -1)), _createVNode(_component_el_date_picker, {
            modelValue: form.firstSendTime,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => form.firstSendTime = $event),
            type: "datetime",
            "value-format": "YYYY-MM-DDTHH:mm:ss",
            format: "YYYY-MM-DD HH:mm",
            class: _normalizeClass(["w-full", {
              'is-error': fieldErrors.firstSendTime
            }]),
            placeholder: "请选择首次提醒时间",
            onBlur: validateFirstSendTime,
            onChange: validateFirstSendTime
          }, null, 8, ["modelValue", "class"]), fieldErrors.firstSendTime ? (_openBlock(), _createElementBlock("p", _hoisted_14, _toDisplayString(fieldErrors.firstSendTime), 1)) : _createCommentVNode("", true)]), _createElementVNode("div", null, [_cache[19] || (_cache[19] = _createElementVNode("label", {
            class: "mb-2 block text-sm font-medium text-slate-700"
          }, "截止时间", -1)), _createVNode(_component_el_date_picker, {
            modelValue: form.deadlineTime,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => form.deadlineTime = $event),
            type: "datetime",
            "value-format": "YYYY-MM-DDTHH:mm:ss",
            format: "YYYY-MM-DD HH:mm",
            class: _normalizeClass(["w-full", {
              'is-error': fieldErrors.deadlineTime
            }]),
            placeholder: "可选，不设置则长期有效",
            onBlur: validateDeadlineTime,
            onChange: validateDeadlineTime
          }, null, 8, ["modelValue", "class"]), fieldErrors.deadlineTime ? (_openBlock(), _createElementBlock("p", _hoisted_15, _toDisplayString(fieldErrors.deadlineTime), 1)) : _createCommentVNode("", true)])]), _createElementVNode("div", _hoisted_16, [_createElementVNode("div", _hoisted_17, [_cache[20] || (_cache[20] = _createElementVNode("div", null, [_createElementVNode("p", {
            class: "text-sm font-medium text-slate-800"
          }, "连续提醒")], -1)), _createVNode(_component_el_switch, {
            modelValue: form.repeatEnabled,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => form.repeatEnabled = $event)
          }, null, 8, ["modelValue"])]), form.repeatEnabled ? (_openBlock(), _createElementBlock("div", _hoisted_18, [_createElementVNode("div", null, [_cache[21] || (_cache[21] = _createElementVNode("label", {
            class: "mb-2 block text-sm font-medium text-slate-700"
          }, "重复间隔", -1)), _createVNode(_component_el_input_number, {
            modelValue: form.repeatIntervalValue,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => form.repeatIntervalValue = $event),
            min: 1,
            max: 9999,
            class: "w-full",
            "controls-position": "right"
          }, null, 8, ["modelValue"])]), _createElementVNode("div", null, [_cache[22] || (_cache[22] = _createElementVNode("label", {
            class: "mb-2 block text-sm font-medium text-slate-700"
          }, "间隔单位", -1)), _createVNode(_component_el_select, {
            modelValue: form.repeatIntervalUnit,
            "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => form.repeatIntervalUnit = $event),
            class: "w-full"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_option, {
              label: "分钟",
              value: "MINUTE"
            }), _createVNode(_component_el_option, {
              label: "小时",
              value: "HOUR"
            }), _createVNode(_component_el_option, {
              label: "天",
              value: "DAY"
            })]),
            _: 1
          }, 8, ["modelValue"])]), _createElementVNode("div", null, [_cache[23] || (_cache[23] = _createElementVNode("label", {
            class: "mb-2 block text-sm font-medium text-slate-700"
          }, "最大提醒次数", -1)), _createVNode(_component_el_input_number, {
            modelValue: form.maxReminderCount,
            "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => form.maxReminderCount = $event),
            min: 1,
            max: 9999,
            class: "w-full",
            "controls-position": "right"
          }, null, 8, ["modelValue"])])])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_19, [_cache[24] || (_cache[24] = _createElementVNode("div", null, [_createElementVNode("p", {
            class: "text-sm font-medium text-slate-800"
          }, "到期自动关闭")], -1)), _createVNode(_component_el_switch, {
            modelValue: form.autoCloseAtDeadline,
            "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => form.autoCloseAtDeadline = $event),
            disabled: !form.deadlineTime
          }, null, 8, ["modelValue", "disabled"])])])])]), _createElementVNode("div", _hoisted_20, [_createElementVNode("p", _hoisted_21, _toDisplayString(footerHint.value), 1), _createElementVNode("div", _hoisted_22, [_createElementVNode("button", {
            type: "button",
            class: "btn-secondary",
            onClick: handleClose
          }, "取消"), _createElementVNode("button", {
            type: "button",
            class: "btn-primary inline-flex items-center gap-2",
            disabled: __props.saving,
            onClick: handleSubmit
          }, [__props.saving ? (_openBlock(), _createElementBlock("svg", _hoisted_24, [...(_cache[26] || (_cache[26] = [_createElementVNode("circle", {
            class: "opacity-25",
            cx: "12",
            cy: "12",
            r: "10",
            stroke: "currentColor",
            "stroke-width": "4"
          }, null, -1), _createElementVNode("path", {
            class: "opacity-75",
            fill: "currentColor",
            d: "M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
          }, null, -1)]))])) : _createCommentVNode("", true), _createTextVNode(" " + _toDisplayString(__props.saving ? '保存中...' : submitText.value), 1)], 8, _hoisted_23)])])]),
          _: 1
        }, 8, ["visible"])]),
        _: 1
      })]);
    };
  }
};